import React, { useEffect } from "react";
import LeaderboardEmployeeTable from "./components/leaderboardEmployeeTable";
import EmployeeCard from "./components/leaderboardEmployeeCard";
import {
  Box,
  Grid, useTheme,
  useMediaQuery,
  Pagination
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeePerformanceOverview } from "../../store/reducers/employeePerformanceOverview";
import { fetchLeaderBoard } from "../../store/reducers/leaderBoard";

const columns = [
  { id: "employee", label: "Employee" },
  { id: "readings", label: "Readings" },
  { id: "total_points", label: "Points Achieved" },
  { id: "trainings", label: "Micro Trainings" },
  { id: "badges", label: "Badges Earned" },
];


const LeaderBoard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [page, setPage] = React.useState(1);
  const itemsPerPage = 10;
  const organizationId = localStorage.getItem("organisation_id");
  const { data: leaderboardData, loading, error } = useSelector(
    (state) => state.leaderBoard
  );
  const data = leaderboardData.slice(0, 5);
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const dispatch = useDispatch()
  const paginatedRows = data.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchLeaderBoard(+organizationId));
    }
  }, [organizationId, dispatch]);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <div
      style={{
        paddingBottom: `${isMobile ? "1rem" : ""}`,
        paddingTop: "1rem",
      }}
    >
      <div
        style={{
          padding: isMobile ? "0" : "2rem",
          backgroundColor: isMobile ? "transparent" : "var(--org-bg-tint-4, #fff0f1)",
          borderRadius: isMobile ? "0" : "16px",
          minHeight: isMobile ? "" : "90vh",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            color: "#2B2B2B",
            marginBottom: isMobile ? "1rem" : "2rem",
            fontSize: isMobile ? "18px" : "24px",
          }}
        >
          Top 5 performers of the Month
        </h3>

        {isMobile ? (
          <div>
            {loading ? <Box
              height="64vh"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <div className="spinner-border text-danger" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Box> : <Grid container spacing={1}>
              {paginatedRows.map((employee, index) => (
                <Grid item xs={12} key={employee.id}>
                  <EmployeeCard
                    data={employee}
                    index={(page - 1) * itemsPerPage + index}
                  />
                </Grid>
              ))}
            </Grid>}

            {data.length > 10 && (
              <Box mt={2} display="flex" justifyContent="center">
                <Pagination
                  count={pageCount}
                  page={page}
                  onChange={handleChangePage}
                  shape="rounded"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "var(--org-bg-color, #f6615f) !important",
                      color: "#fff !important",
                      "&:hover": {
                        backgroundColor: "var(--org-bg-color, #f6615f) !important",
                      },
                    },
                  }}
                />
              </Box>
            )}
          </div>
        ) : (
          <LeaderboardEmployeeTable
            loading={loading}
            columns={columns}
            rows={data}
            title={"Leaderboard"}
          />
        )}
      </div>
    </div>
  );
};

export default LeaderBoard;
